import conf_pc from "../../../assets/images/NewEvent/conf_pc.webp";
import conf_mobi from "../../../assets/images/NewEvent/conf_mobi.webp";
import aufb from "../../../assets/images/Customer/aufb.svg";
import auin from "../../../assets/images/Customer/auin.svg";
import auzl from "../../../assets/images/Customer/auzl.svg";
import { Divider } from "@mui/material";
import top from "../../../assets/images/NewEvent/top.webp";
import EventDetailBody from "../../EventDetail/views/EventDetailBody";

export default function ConferDetailHead() {
  return (
    <div className="w-full">
      <div className="w-full mx-auto container px-[20px] py-[20px] flex flex-col gap-3 md:gap-4">
        <div>
          <p className="text-[16px] text-[#919191] font-normal">
            Sự kiện & hội thảo
          </p>
        </div>
        <div>
          <p className="text-[32px] text-[#1F1F1F] font-semibold">
            Sự kiện nhận giải tưởng TOP 10 sáng kiến tiêu biểu ngành giáo dục
          </p>
        </div>
        <div>
          <img
            src={conf_mobi}
            alt="con1"
            className="block md:hidden w-full h-auto object-cover"
          />
          <img
            src={conf_pc}
            alt="con2"
            className="hidden md:block w-full h-auto object-cover"
          />
        </div>
        <div className="w-full flex flex-col gap-3 md:flex-col bg-[#FAFAFA] px-[16px] py-[16px] rounded-md">
          <div className="w-full flex flex-col md:flex-row gap-5 items-center">
            <div className="w-full flex justify-between items-center">
              <div className="w-full flex flex-col gap-1">
                <p className="text-[16px] text-[#606060] font-medium">
                  Tác giả
                </p>
                <p className="text-[16px] text-[#053CC8] font-medium">
                  Thúy Nga
                </p>
              </div>

              <div class="w-px h-16 bg-gray-300 hidden md:block"></div>

              <div className="w-full flex flex-col gap-1 pl-10">
                <p className="text-[16px] text-[#606060] font-medium">
                  Đăng ngày
                </p>
                <p className="text-[16px] text-[#053CC8] font-medium">
                  20/10/2024
                </p>
              </div>
            </div>
            <div className="w-full block md:hidden">
              <Divider sx={{ borderColor: "gray" }} />
            </div>

            <div class="w-px h-16 bg-gray-300 hidden md:block"></div>

            <div className="w-full flex flex-col gap-1">
              <p className="text-[16px] text-[#606060] font-medium">Chủ đề</p>
              <p className="w-[160px] text-[16px] text-[#053CC8] font-medium">
                Sự kiện & hội thảo
              </p>
            </div>
            <div className="w-full block md:hidden">
              <Divider sx={{ borderColor: "gray" }} />
            </div>
            <div class="w-px h-16 bg-gray-300 hidden md:block"></div>
            <div className="w-full flex flex-col gap-1">
              <p className="text-[16px] text-[#606060] font-medium">
                Thời gian tổ chức
              </p>
              <p className="text-[16px] text-[#053CC8] font-medium">
                08:00, Thứ 6, 25/10/2024
              </p>
            </div>
            <div className="w-full block md:hidden">
              <Divider sx={{ borderColor: "gray" }} />
            </div>
            <div class="w-px h-16 bg-gray-300 hidden md:block"></div>

            <div className="w-full flex flex-col gap-1">
              <p className="text-[16px] text-[#606060] font-medium">Địa điểm</p>
              <p className="text-[16px] text-[#053CC8] font-medium">
                29 Khuất Duy Tiến, Thanh Xuân, Hà Nội.
              </p>
            </div>
            <div className="w-full block md:hidden">
              <Divider sx={{ borderColor: "gray" }} />
            </div>
          </div>
          <div className="w-full hidden md:block">
            <Divider sx={{ borderColor: "#E2E2E2" }} />
          </div>
          <div>
            <div className="w-full flex flex-col gap-1 ">
              <div>
                <p className="text-[16px] text-[#606060] font-medium">
                  Chia sẻ
                </p>
              </div>
              <div className="w-full flex items-center gap-2">
                <img src={aufb} alt="au1" />
                <img src={auin} alt="au2" />
                <img src={auzl} alt="au3" />
              </div>
            </div>
          </div>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat.
          </p>
        </div>
        <div>
          <p className="text-[32px] font-semibold text-center">
            "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet,{" "}
          </p>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Pellentesque mauris massa, maximus eget felis at, interdum lobortis
            urna. Orci varius natoque penatibus et magnis dis parturient montes,
            nascetur ridiculus mus. Fusce id arcu vehicula, convallis mauris sit
            amet, ullamcorper elit. Mauris varius tortor quis massa ultricies,
            eu lacinia felis ultricies. Suspendisse at tellus efficitur, cursus
            libero at, interdum massa. Proin at enim vel tellus consectetur
            accumsan pellentesque vitae sem. Etiam in vestibulum nulla, non
            sodales dui. Phasellus imperdiet vel nulla sed pharetra.
          </p>
        </div>
        <div className="w-full flex flex-col md:flex-row gap-3">
          <div className="w-full">
            <img src={top} alt="top1" className="w-full h-auto object-cover" />
          </div>
          <div className="w-full">
            <p>
              Ut ultricies mauris sed arcu imperdiet sodales eu vitae nisl.
              Etiam ac nisl ac nisi imperdiet pellentesque quis gravida nunc.
              Integer in tincidunt elit. Nullam hendrerit scelerisque tellus sit
              amet porttitor. Cras cursus nulla vel egestas gravida. Mauris
              luctus urna non auctor venenatis. Nam egestas suscipit lorem eu
              auctor. Cras non tempor sapien. Proin lobortis faucibus
              pellentesque. Aliquam eu turpis in odio lobortis auctor. Maecenas
              eget suscipit diam, at rhoncus nisl. Sed dolor diam, convallis sed
              ligula sit amet, lacinia cursus massa. Maecenas varius diam purus,
              ac porttitor urna congue sed. Ut faucibus nulla nec elit
              consectetur, quis venenatis arcu bibendum. Class aptent taciti
              sociosqu ad litora torquent per conubia nostra, per inceptos
              himenaeos. Phasellus mi turpis, vulputate sed neque quis, volutpat
              bibendum elit. Etiam consectetur mauris elit, non feugiat mi
              semper at. Nam vel ligula sed lacus molestie sodales sit amet quis
              urna. Nullam ornare nulla odio, vitae convallis ipsum lacinia et.
              Duis sit amet pretium dolor. Fusce ultrices tellus non magna
              facilisis gravida. Aliquam erat volutpat.
            </p>
          </div>
        </div>
        <div>
          <p>
            Sed et imperdiet magna. Praesent imperdiet egestas ornare.
            Pellentesque ut urna at diam elementum viverra non vitae nisi.
            Curabitur eu erat id ligula molestie ornare. In non urna eu tellus
            sodales sollicitudin eu vitae odio. Suspendisse potenti. Nullam ac
            justo congue, ullamcorper elit faucibus, luctus lorem. Mauris
            tristique ipsum non purus viverra, sit amet ullamcorper nisl
            laoreet. Donec fermentum accumsan bibendum.
          </p>
        </div>
        <div>
          <p>Theo, Nguyễn Văn B</p>
        </div>
      </div>
      <EventDetailBody />
    </div>
  );
}
